import { render, staticRenderFns } from "./AulaSearchRecipients.vue?vue&type=template&id=aa22c826&scoped=true&"
import script from "./AulaSearchRecipients.vue?vue&type=script&lang=js&"
export * from "./AulaSearchRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa22c826",
  null
  
)

export default component.exports